module.exports = __webpack_public_path__ + "img/map.5eddb54.webp";